import { COLORS } from '@btime/constants'
import React from 'react'

import { MapsContext } from '../../../components/map/MapContext'
import { PermissionChecker } from '../../session'
import { Relative } from '../../../components/helpers/Position'
import AbsoluteWithMenuSpacePageTemplate from '../../../components/templates/AbsoluteWithMenuSpacePageTemplate'
import MapContent from './MapContent'
import MapPointsLoader from './_load/MapPointsLoader'
import ClusterPanel from './cluster/ClusterPanel'
import RouterPanel from './router/RouterPanel'

const MapPage = () => {
  return (
    <AbsoluteWithMenuSpacePageTemplate bgColor={COLORS.white}>
      <PermissionChecker permission="seeMap">
        <MapsContext>
          <MapPointsLoader>
            <Relative>
              <MapContent />
              <ClusterPanel />
              <RouterPanel />
            </Relative>
          </MapPointsLoader>
        </MapsContext>
      </PermissionChecker>
    </AbsoluteWithMenuSpacePageTemplate>
  )
}

export default MapPage
